import { createFetcher } from "api/helpers"
const fetcherConfiguration = {
  method: "get",
  makeRequestUrl: (host, project, params) => {
    return `${host}/security/${project}/get_vulnerability_subtype?${params}`
  },
  checkRequiredArguments: (params) => {
    if (params === undefined);
  },
  makeResponseData: (json) => {
    return json
  }
}
export default createFetcher(fetcherConfiguration)
